import {createFeatureSelector} from "@ngrx/store";

import * as fromUserContext from './userContextStore/context.reducers';
import * as fromGeneral from '../pages/general.reducers';

export interface AppState {
    general: fromGeneral.IGeneralState,
    userContext: fromUserContext.UserContext,
}

export const reducers = {
    general: fromGeneral.reducer,
    userContext: fromUserContext.reducer,
}


export function clearState(reducer) {
    return (state, action) => {
        //
        // A revoir....
        //
        // if (action.type === AuthActionTypes.LOGOUT) {
        //     // console.log('>>>> Clear state !');
        //     state = undefined;
        // }
        return reducer(state, action);
    };
}

export const selectUserContextState = createFeatureSelector<fromUserContext.UserContext>('userContext');

export const selectGeneralState = createFeatureSelector<fromGeneral.IGeneralState>('general');

